import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {CrmDocumentSummary} from '../models/api/crm/CrmDocumentSummary';
import {OfferingCreateInput} from '../models/api/crm/OfferingCreateInput';
import {OfferingDetails} from '../models/api/crm/OfferingDetails';
import {OfferingSummary} from '../models/api/crm/OfferingSummary';
import {OfferingUpdateInput} from '../models/api/crm/OfferingUpdateInput';

@Injectable({
  providedIn: 'root'
})
export class OfferingApiService {
  private static readonly OFFERINGS_URL = `${environment.apiUrl}/offerings`;
  private static readonly OFFERING_DOCUMENTS_URL = `${environment.apiUrl}/offerings/{offeringId}/documents`;
  private static readonly OFFERING_DOCUMENT_URL = `${environment.apiUrl}/offerings/{offeringId}/documents/{documentId}`;
  private static readonly OFFERING_DOCUMENT_DOWNLOAD_URL = `${environment.apiUrl}/offerings/{offeringId}/documents/{documentId}/download`;

  constructor(private readonly http: HttpClient) {}

  public getOfferings(): Observable<OfferingSummary[]> {
    return this.http.get<OfferingSummary[]>(OfferingApiService.OFFERINGS_URL);
  }

  public getOffering(offeringId: string): Observable<OfferingDetails> {
    return this.http.get<OfferingDetails>(`${OfferingApiService.OFFERINGS_URL}/${offeringId}`);
  }

  public createOffering(payload: OfferingCreateInput): Observable<OfferingDetails> {
    return this.http.post<OfferingDetails>(OfferingApiService.OFFERINGS_URL, payload);
  }

  public updateOffering(offeringId: string, payload: OfferingUpdateInput): Observable<OfferingDetails> {
    return this.http.put<OfferingDetails>(`${OfferingApiService.OFFERINGS_URL}/${offeringId}`, payload);
  }

  public deleteOffering(offeringId: string): Observable<void> {
    return this.http.delete<void>(`${OfferingApiService.OFFERINGS_URL}/${offeringId}`);
  }

  public getOfferingDocuments(offeringId: string): Observable<CrmDocumentSummary[]> {
    return this.http.get<CrmDocumentSummary[]>(
      OfferingApiService.OFFERING_DOCUMENTS_URL.replace('{offeringId}', offeringId)
    );
  }

  public uploadOfferingDocument(offeringId: string, file: File): Observable<CrmDocumentSummary> {
    const formData = new FormData();
    formData.append('file', file, file.name);

    return this.http.post<CrmDocumentSummary>(
      OfferingApiService.OFFERING_DOCUMENTS_URL.replace('{offeringId}', offeringId),
      formData
    );
  }

  public downloadOfferingDocument(offeringId: string, documentId: string): Observable<Blob> {
    return this.http.get(
      OfferingApiService.OFFERING_DOCUMENT_DOWNLOAD_URL
        .replace('{offeringId}', offeringId)
        .replace('{documentId}', documentId),
      {
        responseType: 'blob'
      }
    );
  }

  public deleteOfferingDocument(offeringId: string, documentId: string): Observable<void> {
    return this.http.delete<void>(
      OfferingApiService.OFFERING_DOCUMENT_URL
        .replace('{offeringId}', offeringId)
        .replace('{documentId}', documentId)
    );
  }
}
